import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';


export interface LoaderProps {
    centered ?: boolean,
    paddingTop ?: string,
    size ?: number,
    color ?: string
}

export default function Loader({centered, paddingTop, size , color = 'black'}: LoaderProps) {

    const dynamicStyle = centered ? {display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', paddingTop: paddingTop || "0"} : {}
  return (
    <div style={{...dynamicStyle, color}}>
      <CircularProgress size={size} style={{color}}/>
    </div>
  )
}

export const LoaderSreen = ({heigth = '100%'}:{heigth: number | string}) => {
  return (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: heigth}}>
      <CircularProgress />
    </div>
  )
}